import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '../src/index.css';

// Import Firebase configuration from main app
import './lib/firebase';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);